import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasFeatureAccess, getStoredUser, isOrganizationOwner } from '../../utils/rbac';
import AccessDenied from './AccessDenied';

/**
 * Reusable Route and Component Guard that verifies user permissions for a specific feature.
 *
 * @param {string} feature - Feature name (e.g. 'Devices', 'Windows Agent Devices')
 * @param {string} action - 'read' | 'create' | 'update' | 'delete' (default: 'read')
 * @param {React.ReactNode} children - Optional wrapped element
 */
export const PermissionGuard = ({ feature, action = 'read', children }) => {
  const user = getStoredUser();

  // If unauthenticated, redirect to login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Superadmin / Org owner always has access
  if (isOrganizationOwner(user)) {
    return children ? <>{children}</> : <Outlet />;
  }

  const hasAccess = hasFeatureAccess(user, feature, action);

  if (!hasAccess) {
    return <AccessDenied featureName={feature} />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PermissionGuard;
